"use strict";

// Section name
(function () {
  jQuery(document).ready(function () {
    //PRODUCT SLIDER MODAL QUICK ADD
    function initSlider() {
      const swiperSingleProduct = new Swiper(".single-product-slider", {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }

    /// variants picker ///
    function onOptionChange() {
      let currentColor = $(".color-picker input[name='color']:checked").val();
      let currentMaterial = $(
        ".color-picker input[name='material']:checked"
      ).val();
      let variant_id;

      jQuery.each(productObj.variants, function (index, itemData) {
        if (
          itemData.option1 === currentColor &&
          itemData.option2 === currentMaterial
        ) {
          variant_id = itemData.id;
        }
      });

      let gallerySlider = $(".swiper-wrapper[data-image-slideshow]").html("");
      jQuery.each(imageGallery, function (index, selectedVariant) {
        if (selectedVariant[0] === variant_id) {
          jQuery.each(selectedVariant[1], function (index, variantImages) {
            gallerySlider.append(
              `<div class="swiper-slide" data-index="${index}"><img src="${variantImages}" class="w-100"></div>`
            );
          });
        }
      });

      initSlider();
    }

    const colorInput = $(".color-picker input[name='color']");

    colorInput.each(function (index) {
      if (index === 0) {
        $(this).prop("checked", true);
      }

      if ($(this).is(":checked")) {
        $(".color-title[data-color-title]").text($(this).val());
        $(this).next().addClass("selected");
      }
    });

    colorInput.on("change", function () {
      $(".color-picker.color .btn").removeClass("selected");
      $(".color-title[data-color-title]").text($(this).val());
      $(this).next().addClass("selected");

      onOptionChange();
    });

    const materialInput = $(".color-picker input[name='material']");

    materialInput.each(function (index) {
      if (index === 0) {
        $(this).prop("checked", true);

        onOptionChange();
      }

      if ($(this).is(":checked")) {
        $(".color-title[data-material-title]").text($(this).val());
        $(this).next().addClass("selected");

        onOptionChange();
      }
    });

    materialInput.on("change", function () {
      $(".color-picker.material .btn").removeClass("selected");
      $(".color-title[data-material-title]").text($(this).val());
      $(this).next().addClass("selected");

      onOptionChange();
    });

    /// End variant picker ///

    onOptionChange();

    /// Compairing variants with selected options ///
    $(".add-to-cart-button").click(function () {
      let currentColor = $(".color-picker input[name='color']:checked").val();
      let currentMaterial = $(
        ".color-picker input[name='material']:checked"
      ).val();
      let currentPrice = $(".single-product-info .price span").data("price");
      let variant_id;
      let qty = $(".product-qty").val();

      jQuery.each(productObj.variants, function (index, itemData) {
        if (
          itemData.option1 === currentColor &&
          itemData.option2 === currentMaterial
        ) {
          variant_id = itemData.id;
        }
      });

      addItemToCart(
        variant_id,
        qty,
        productObj,
        currentColor,
        currentMaterial,
        currentPrice
      );
    });

    function closeModalOnSuccess() {
      $(".product-modal.modal-window").fadeOut(500);
      $(".load_content_quick_view").html("");
    }

    function addItemToCart(
      variant_id,
      qty,
      productObj,
      currentColor,
      currentMaterial,
      currentPrice
    ) {
      let data = {
        id: variant_id,
        quantity: qty,
      };

      let cartData = {
        title: productObj.title,
        image: productObj["featured_image"],
        color: currentColor,
        material: currentMaterial,
        price: currentPrice,
        quantity: qty,
      };

      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          triggerCartModal(cartData);
          closeModalOnSuccess();
        },
        error: function (error) {
          alert(
            error.responseJSON.message + "\r\n" + error.responseJSON.description
          );
        },
      });
    }

    function triggerCartModal(cartData) {
      const modalCart = $('.modal-window[data-id="modal_three"]');
      modalCart.addClass("modal-open");
      modalCart.fadeIn();

      $(".cart-wrap .product-name").text(cartData["title"]);
      $(".cart-wrap .product-price").text("$" + cartData["price"]);
      $(".cart-wrap span[data-added-product-qty]").text(cartData["quantity"]);
      $(".cart-wrap span[data-added-product-color]").text(cartData["color"]);
      $(".cart-wrap span[data-added-product-material]").text(
        cartData["material"]
      );
      $(".added-to-cart-content img").attr("src", cartData["image"]);
    }
  });
})(jQuery);
//END Section name
